import { isValidHomeDepotItemId } from "components/hostedScrapingValidators";
import { SDEContent } from "./sdecontentTypes";

export const HomeDepotProductContent: SDEContent = {
  projectType: 'async_homedepot_product',
  projectCategory: 'homedepot',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/structured/homedepot/product/v1`;
  },
  docsSection: 'homedepot-product-api',
  docsSectionTitle: 'Home Depot Product API',
  docsSectionAsync: 'homedepot-product-api-async',
  docsSectionAsyncTitle: 'Home Depot Product API (Async)',
  inputKey: 'item_id',
  inputsKey: 'item_ids',
  validatorFunction: isValidHomeDepotItemId,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'Item IDs',
      listLiteralInputPlaceholder: 'Enter one Home Depot item ID per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: "Input item ID",
      inputSectionDescription: "Enter Home Depot item IDs in the input field or upload a CSV with your item IDs to begin scraping Home Depot.",
    },
    projectContent: {
      title: 'Home Depot product',
      description: 'Extract well-structured product data from a Home Depot product page like title, price, rating, model number and specifications.',
      icon: 'homedepot',
      inputTitle: 'Item ID',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input item ID',
      inputSectionDescription: 'Enter Home Depot item IDs to begin scraping Home Depot.',
    },
    projectContent: {
      title: 'Home Depot product',
      description: 'Extract well-structured product data from a Home Depot product page.',
      icon: 'homedepot',
    },
    enterInputsPlaceholder: '320326855',
    enterInputsMessage: 'Enter item ID for scraping',
    codeViewPlaceHolder: 'Please provide a valid item ID',
    dropdownTitle: 'Home Depot Product'
  }
};
